function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { createBaseComponent } from '@semcore/core';
import Icon from '../../lib/esm/index.mjs';
function RootSearch({
  width = '16',
  height = '16',
  viewBox = '0 0 16 16',
  ...props
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    "data-name": "Search",
    "data-group": "m",
    width: width,
    height: height,
    viewBox: viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m14.704 13.285-4.537-4.537a4.997 4.997 0 1 0-1.419 1.42l4.537 4.536a1 1 0 0 0 1.638-.325.998.998 0 0 0-.219-1.094ZM3.002 6a2.998 2.998 0 1 1 5.996 0 2.998 2.998 0 0 1-5.996 0Z",
    shapeRendering: "geometricPrecision"
  }));
}
RootSearch.displayName = 'Search';
const Search = createBaseComponent(RootSearch);
export { Search as default };